import { render, staticRenderFns } from "./PlanoDeAcao.vue?vue&type=template&id=646b877a&scoped=true&"
import script from "./PlanoDeAcao.vue?vue&type=script&lang=js&"
export * from "./PlanoDeAcao.vue?vue&type=script&lang=js&"
import style0 from "./PlanoDeAcao.vue?vue&type=style&index=0&id=646b877a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646b877a",
  null
  
)

export default component.exports